import PolicyLayout from './PolicyLayout';
import { SITE_DOMAIN, SITE_NAME } from '../constants/site';

export default function RefundPolicy() {
  return (
    <PolicyLayout title="Refund Policy">
      <p>
        Effective date: April 9, 2026. {SITE_NAME} at <strong>{SITE_DOMAIN}</strong> primarily provides informational website content and support
        guidance. Where paid consultation or service engagements are offered, this Refund Policy applies.
      </p>
      <h2>Scope</h2>
      <p>
        This policy applies only to eligible paid services directly provided through this website and does not
        apply to third-party products, software licenses, or external vendor transactions.
      </p>
      <h2>Eligibility Window</h2>
      <p>
        Refund requests must be submitted within 7 calendar days of the purchase date, including transaction details
        and a clear reason for the request.
      </p>
      <h2>Eligible Scenarios</h2>
      <p>
        Refunds may be approved if (a) a paid service was not delivered as described, (b) a duplicate transaction was
        charged, or (c) service cancellation is accepted before work begins.
      </p>
      <h2>Non-Refundable Cases</h2>
      <p>
        Completed consultation sessions, partially or fully delivered custom paid assistance work, downloadable
        materials once delivered, and delays caused by missing user information are generally non-refundable.
      </p>
      <h2>Request Process</h2>
      <p>
        Submit requests through our live chat support with your full name, order or payment reference, purchase date,
        service details, and reason for refund. Additional verification may be required before processing.
      </p>
      <h2>Processing Timeline</h2>
      <p>
        Approved refunds are typically initiated within 7 to 10 business days. Final posting time depends on your
        bank, card issuer, or payment gateway provider.
      </p>
      <h2>Policy Revisions</h2>
      <p>
        This policy may be updated periodically. The latest published version on this page applies to future
        transactions and requests received after the update date.
      </p>
    </PolicyLayout>
  );
}
